import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  isMobile,
  isIOsSafari,
  isIOS,
  setCookie,
  getCookie,
} from '../../utils'
import './android-banner.scss'

export default function AndroidBanner() {
  const [isVisible, setVisibility] = useState(!getCookie('android-banner'))

  const handleClose = () => {
    setCookie('android-banner', 'true', { expires: 60 * 3 }) // 3 hours
    setVisibility(false)
  }

  if(isMobile() && !isIOsSafari() && isVisible) {
    return (
      <div className='android-banner'>
        <i className='font-icons close-icon' onClick={handleClose} />
        <img
          src={`${window.staticPath}travel_dist/images/padi-app-logo.png`}
          width='80px'
          height='80px'
          alt='PADI Adventures'
        />
        <div className='android-banner__text'>
          <span className='android-banner__title'>
            <FormattedMessage
              id='padi_adventures'
              defaultMessage='PADI Adventures'
            />
          </span>
          <FormattedMessage
            id='app_better'
            defaultMessage='The app is better and faster'
          />
        </div>
        <a
          href={
            isIOS()
              ? 'https://apps.apple.com/us/app/padi-adventures-book-diving/id1497105546'
              : 'https://play.google.com/store/apps/details?id=com.padi'
          }
          className='btn-red'
          onClick={handleClose}
        >
          <FormattedMessage id='install' defaultMessage='Install' />
        </a>
      </div>
    )
  }

  return null
}
